import { createOriginFunctionAnnotation } from '../lambdas'
import {
  actionBound as originBound,
  action as originFn
} from '../operations/register'

export const action = createOriginFunctionAnnotation(
  'action',
  originFn,
  originBound
)
